<template>
  <v-card :loading="loading" class="elevation-12">
    <v-card-title>{{ $t('createMailFromPdf.title') }}</v-card-title>
    <v-card-text>
      <v-text-field v-model="receiver"
                    :label="$t('createMailFromPdf.receiverLabel')"
                    :error-messages="receiverErrors"
      />
      <v-text-field v-model="street"
                    :label="$t('createMailFromPdf.streetLabel')"
                    :error-messages="streetErrors"
      />
      <v-text-field v-model="home"
                    :label="$t('createMailFromPdf.homeLabel')"
                    :error-messages="homeErrors"
      />
      <v-autocomplete v-model="region"
                      :items="$store.getters.appRegions"
                      :item-value="item => item"
                      :item-text="item => item.name"
                      :label="$t('createMailFromPdf.regionLabel')"
                      :error-messages="regionErrors"
                      @change="onChangeRegion"
      />
      <v-autocomplete v-model="area"
                      :items="regionAreas"
                      :item-value="item => item"
                      :item-text="item => item.name"
                      :label="$t('createMailFromPdf.areaLabel')"
                      :error-messages="areaErrors"
                      :disabled="!region"
      />

      <v-file-input v-model="file"
                    show-size
                    :label="$t('createMailFromPdf.pdfLabel')"
                    accept="application/pdf"
                    :error-messages="fileErrors"
      />
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn color="primary" @click="onCreateClicked">{{ $t('createMailFromPdf.createBtn') }}</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isCreateFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      {{ $t('createMailFromPdf.creationFailedSnack') }}
    </v-snackbar>
  </v-card>
</template>

<script>
import {required, maxLength} from 'vuelidate/lib/validators'
import MailCreateService from '../../../services/mail.create.service'
import AreaService from '@/services/area.service'
import Mapper from '../../../mappers'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import {MAIL_CREATED} from "@/events/mail";
import _ from 'underscore'

export default {
  name: "MailCreatePdfFormComponent",
  data() {
    return {
      receiver: '',
      street: '',
      home: '',
      region: null,
      area: null,
      file: null,

      loading: false,
      isCreateFailed: false,

      regionAreas: []
    }
  },
  validations: {
    receiver: {
      required,
      maxLength: maxLength(600)
    },
    address: {
      required,
      maxLength: maxLength(600)
    },
    region: {
      required
    },
    area: {
      required
    },
    file: {
      required
    }
  },
  computed: {
    address() {
      return this.street + ", " + this.home
    },
    receiverErrors() {
      const errors = []

      if (this.$v.receiver.$dirty) {
        if (!this.$v.receiver.required) {
          errors.push(this.$t('createMailFromPdf.receiverRequiredError'))
        } else {
          !this.$v.receiver.maxLength && errors.push(this.$t('createMailFromPdf.receiverMaxLengthError'))
        }
      }

      return errors
    },
    streetErrors() {
      const errors = []

      if (this.$v.address.$dirty) {
        if (!this.$v.address.required) {
          errors.push(this.$t('createMailFromPdf.streetRequiredError'))
        } else {
          !this.$v.address.maxLength && errors.push(this.$t('createMailFromPdf.streetMaxLengthError'))
        }
      }

      return errors
    },
    homeErrors() {
      const errors = []

      if (this.$v.address.$dirty) {
        if (!this.$v.address.required) {
          errors.push(this.$t('createMailFromPdf.homeRequiredError'))
        } else {
          !this.$v.address.maxLength && errors.push(this.$t('createMailFromPdf.homeMaxLengthError'))
        }
      }

      return errors
    },
    regionErrors() {
      const errors = []

      if (this.$v.region.$dirty) {
        if (!this.$v.region.required) {
          errors.push(this.$t('createMailFromPdf.regionRequiredError'))
        }
      }

      return errors
    },
    areaErrors() {
      const errors = []

      if (this.$v.area.$dirty) {
        if (!this.$v.area.required) {
          errors.push(this.$t('createMailFromPdf.areaRequiredError'))
        }
      }

      return errors
    },
    fileErrors() {
      const errors = []

      if (this.$v.file.$dirty) {
        if (!this.$v.file.required) {
          errors.push(this.$t('createMailFromPdf.fileRequiredError'))
        }
      }

      return errors
    }
  },
  methods: {
    onCreateClicked() {
      this.$v.$touch()

      if (!this.$v.$invalid) {

        this.isCreateFailed = false
        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)
        // let address = this.street + " " + this.home

        const reader = new FileReader()
        reader.onload = () => {
          MailCreateService.createFormPdfFile({
            receiver: this.receiver,
            address: this.address,
            region: this.region,
            area: this.area,
            document64: reader.result.split(',')[1]
          })
              .then(response => {
                let mail = Mapper.mapMail(response.data)
                this.$bus.$emit(MAIL_CREATED, mail)
              }, () => {
                this.isCreateFailed = true
              })
              .catch(() => {

              })
              .finally(() => {
                this.loading = false;
                this.$store.dispatch(LAYOUT_LOADING_STOP)
              })
        }
        reader.readAsDataURL(this.file)
      }
    },
    onChangeRegion() {
      this.regionAreas = []
      this.area = null

      if (this.region) {
        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)

        AreaService.getAll(this.region.id)
            .then(response => {
              this.regionAreas = _.map(response.data, areaViewModel => {
                return Mapper.mapArea(areaViewModel)
              })
            })
            .finally(() => {
              this.loading = false;
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    }
  }
}
</script>

<style scoped>

</style>